import { render, staticRenderFns } from "./topRight.vue?vue&type=template&id=0f6992c0&"
import script from "./topRight.vue?vue&type=script&lang=js&"
export * from "./topRight.vue?vue&type=script&lang=js&"
import style0 from "./topRight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports